import {interventionPropTypes} from '../../../utils/propTypes';

function ProjectTreeRowOrganisationContact(props) {
  const {intervention} = props;
  return (
    <div data-id="organisation-data-contact">
      {intervention.email ?
        <a
          href={`mailto:${intervention.email}`}
          target="_blank"
          rel="noopener noreferrer"
          data-id="organisation-data-email"
          onClick={event => event.stopPropagation()}
        >
          {intervention.email}
        </a> :
        <div className="d-flex flex-column align-items-end">
          <div data-id="addressLine">{intervention.organisation.address.addressLine}</div>
          <div data-id="postCodeCity">{intervention.organisation.address.postCode} {intervention.organisation.address.city}</div>
        </div>
      }
    </div>
  );
}

ProjectTreeRowOrganisationContact.propTypes = {
  intervention: interventionPropTypes().isRequired
};

export default ProjectTreeRowOrganisationContact;
